// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c7c7475","239":"4dda6de1","453":"e858e143","455":"cb32ab8d"}[chunkId] + ".chunk.js";
};